const ITEMS = [
  "COLLISION REPAIR",
  "★",
  "CUSTOM PAINT",
  "★",
  "AUTO BODY",
  "★",
  "TRUCK REPAIR",
  "★",
  "INSURANCE ACCEPTED",
  "★",
  "FRAME WORK",
  "★",
  "MECHANICAL",
  "★",
  "FREE ESTIMATES",
  "★",
];

export default function MarqueeStrip() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-zinc-900 text-white border-y border-zinc-800 overflow-hidden">
      <div className="marquee-row py-3 sm:py-4 whitespace-nowrap font-display font-black tracking-[0.15em] text-base sm:text-xl">
        {doubled.map((it, i) => (
          <span key={i} className={it === "★" ? "text-brand-red" : "text-white"}>
            {it}
          </span>
        ))}
      </div>
    </div>
  );
}
